import { render, staticRenderFns } from "./TiktracMini.vue?vue&type=template&id=4b4d59bb&scoped=true&"
import script from "./TiktracMini.vue?vue&type=script&lang=ts&"
export * from "./TiktracMini.vue?vue&type=script&lang=ts&"
import style0 from "./TiktracMini.vue?vue&type=style&index=0&id=4b4d59bb&prod&lang=scss&"
import style1 from "./TiktracMini.vue?vue&type=style&index=1&id=4b4d59bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d59bb",
  null
  
)

export default component.exports